/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';
import { IDialogOptions, IModalData, openGlobalModal } from 'app/shared/elements/ess-global-modal';
import * as CM from 'app/cm/models/essette-api';

export interface ICaseAuditLogModelData {
    case: CM.Case;
}

@autoinject()
export class CaseAuditLog extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected caseId: string | null = null

    protected auditLogSections: Record<string, boolean> = {};

    protected sectionVisibility = {
        caseInformation: false,
        careTeam: false,
        carePlan: false,
        tasks: false,
        diagnoses: false,
        statusHistory: false,
        routing: false,
        services: false
    }

    protected id: guid = guid();

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected async activate(model: ICaseAuditLogModelData): Promise<void> {
        if(!model.case.id) return;
        await this.checkPermissions();

        this.caseId = model.case.id;
    }

    ////****************** Events ***************************************************////
    protected openSection(sectionId: string): void {
        const section = sectionId.replace('-collapsible', '');
        this.auditLogSections[section] = true;
    }

    ////****************** Functions ************************************************////
    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();

        this.sectionVisibility.caseInformation = this.accountContext.hasRouteAccess('cm.case');
        this.sectionVisibility.careTeam = this.accountContext.hasRouteAccess('cm.case.careteam');
        this.sectionVisibility.carePlan = this.accountContext.hasRouteAccess('cm.case.careplan');
        this.sectionVisibility.tasks = this.accountContext.hasRouteAccess('cm.case.tasks');
        this.sectionVisibility.diagnoses = this.accountContext.hasRouteAccess('cm.case.member-diagnoses');
        this.sectionVisibility.statusHistory = this.accountContext.hasRouteAccess('cm.case.status');
        this.sectionVisibility.routing = this.accountContext.hasRouteAccess('cm.case.routing');
        this.sectionVisibility.services = this.accountContext.hasRouteAccess('cm.case.services');
    }

}


/**
 * Opens the case audit log modal with the global dialog
 * @param case The case information to use
 */
export function openCaseAuditLog(caseInfo: CM.Case | null): void {
    if(!caseInfo || !caseInfo.id) {
        throw new Error('Case is missing or invalid');
    }

    const dialogOptions: IDialogOptions = {
        width: '10',
        height: '11',
        helpTopic: 'cm.case.audit-log',
        title: {
            key: 'cm:routes.case.audit-log.$title',
            replace: { number: caseInfo.number }
        },
        print: true,
        popout: {
            route: 'cm.case.audit-log',
            params: { caseId: caseInfo.id }
        }
    };

    const modelData: ICaseAuditLogModelData = {
        case: caseInfo
    };

    const modalData: IModalData = {
        componentId: 'app/cm/components/audit-log/case-audit-log',
        modelData: modelData,
        dialogOptions: dialogOptions
    };

    openGlobalModal(modalData);
}

